import BreadCrumb from "Components/Common/BreadCrumb";
import "react-toastify/dist/ReactToastify.css";
import { Card, Container, Input } from "reactstrap";
import "./MarketingCampaign.scss";
import { useEffect, useState } from "react";
import { getRegisteredCampaignThunk } from "live-slices/Marketing-Campaign/thunk";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { Link, useNavigate } from "react-router-dom";
import { getMarketingRegistered } from "helpers/backend_helper";


const SubmissionHistory = (props: any) => {

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalCount, settotalCount] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const itemsPerPage = 10;
  const [loadingCampaign, setLoadingCampaign] = useState<boolean>(true);
  const [apiData, setCampaignData] = useState<any[]>([]);
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
const [selectedCampaignId, setSelectedCampaignId] = useState<string>('');

  // const selecteRegisteredData = createSelector(
  //   (state: any) => state.Campaign,
  //   (campaignRegistered) => campaignRegistered?.campaignRegistered
  // );
  // const apiData = useSelector(selecteRegisteredData);


  useEffect(() => {
    getCompaign(currentPage)
  }, [dispatch, currentPage, selectedCampaignId]);


  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const getCompaign = async (page: number) => {
    try {
      setLoadingCampaign(true);
      const response = await
        getMarketingRegistered(page, itemsPerPage, selectedCampaignId);
      if (response?.data) {
        setCampaignData(response.data.data);
        settotalCount(response.data.totalCount);
        setTotalPages(Math.ceil(response.data.totalCount / itemsPerPage));
      }
    } catch (err: any) {
    } finally {
      setLoadingCampaign(false);
    }
  };
  const handleSelectChange = (event: any) => {
    const selectedCampaign = event.target.value;
    setSelectedCampaignId(selectedCampaign)
    dispatch(
      getRegisteredCampaignThunk({
        page: 1,
        count: 10,
        campaignId: selectedCampaignId, // send selected ID in keyword
      })
    );
  };

  const formatDate = (dateString: any) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).format(date).replace(',', '');
  };

  const handleRegister = async (campaignId: any) => {
    try {
      navigate(`/Campaign-Register/${campaignId}`);
    } catch (err) {
      console.error('API failed:', err);
    }
  };



  return (
    <div className="page-content SubmissionHistoryMainPage">
      <Container fluid>
        <BreadCrumb
          title="Submission History"
          pageTitle="Promotion"
          pageTitleRoute="/promotion"
        />
        <Card className="SubmissionHistoryMainCard">
          <div className="searchAndSelect">
            <div className="input">
              <input
                type="text"
                placeholder="Campaigns"
                data-testing-id="searchInput_SubmissionHistory"
              />
            </div>
            <select data-testing-id="selectOption_CampaignData" onChange={handleSelectChange}>
              <option disabled selected>
                Select a campaign
              </option>
              {apiData && apiData?.length && apiData.map((item: any, index: number) => (
                <>
                  <option
                    value={item?.campaign?._id}
                    data-testing-id="pleaseSelectOption_CampaignData"
                  >
                    {item?.campaign?.name}
                  </option>
                </>
              ))
              }
            </select>
          </div>
        </Card>
        <Card className="SubmissionHistoryMainCard">
          <h1>Submission History</h1>
          <div className="SubmissionHistoryListing_Main">
            <table className="w-100">
              <thead>
                <tr>
                  <th className="top-left">
                    <p>
                      <span>Campaign ID</span>
                    </p>
                  </th>
                  <th>
                    <p>
                      <span>Campaign Name</span>
                    </p>
                  </th>
                  <th>
                    <p>
                      <span>Registration Date</span>
                    </p>
                  </th>
                  <th>
                    <p>
                      <span>Live Date</span>
                    </p>
                  </th>
                  <th>
                    <p>
                      <span>Submitted Skus</span>
                    </p>
                  </th>
                  <th>
                    <p>
                      <span>Approved Skus</span>
                    </p>
                  </th>
                  <th className="top-right">
                    <p>
                      <span>Action</span>
                    </p>
                  </th>
                </tr>
              </thead>
              <tbody>
                {apiData && apiData?.length && apiData.map((item: any, index: number) => (
                  <tr key={index}>
                    <td><p>{item?.campaign?._id}</p></td>
                    <td><p>{item?.campaign?.name}</p></td>
                    <td>
                      <p>
                        {formatDate(item?.createdOn)}
                      </p>
                    </td>
                    <td>
                      <p>
                        {formatDate(item?.campaign?.timeline?.megaDurationStartTime)}
                      </p>
                    </td>
                    <td><p><span>{item?.products?.length}</span></p></td>
                    <td><p><span>{item.approvedCount}</span></p></td>
                    <td>
                      <button onClick={() => handleRegister(item?.campaign?._id)} data-testing-id={"View-Detail " + index}>View Detail</button>
                    </td>

                  </tr>
                ))}
              </tbody>

            </table>
          </div>
          <div className="paginationDv mt-4 d-flex justify-content-end">
            <nav aria-label="Page navigation example">
              <ul className="pagination detailPagepagi m-0">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""
                    }`}
                >
                  <button
                    onClick={() => handlePrevious()}
                    style={{
                      height: "26px",
                      display: "flex",
                      alignItems: "center",
                      border: "none",
                    }}
                    className="page-link"
                  >
                    <i
                      style={{ height: "11px" }}
                      className="bx bxs-left-arrow"
                    ></i>
                  </button>
                </li>

                {Array.from({ length: totalPages }, (_, i) => (
                  <li
                    key={i}
                    className={`page-item ${currentPage === i + 1 ? "active" : ""
                      }`}
                  >
                    <button
                      onClick={() => handlePageChange(i + 1)}
                      className="page-link orderPg"
                      style={{ height: "26px" }}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}

                <li
                  className={`page-item ${currentPage === totalPages ? "disabled" : ""
                    }`}
                >
                  <button
                    onClick={() => handleNext()}
                    className="page-link orderPg"
                    style={{
                      height: "26px",
                      display: "flex",
                      alignItems: "center",
                      border: "none",
                    }}
                  >
                    <i
                      className="bx bxs-right-arrow"
                      style={{ width: "6px", height: "11px" }}
                    ></i>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </Card>
      </Container>
    </div >
  );
};

export default SubmissionHistory;
